/**
 * Form Category and Type API Client
 * Lookup data — mirrors old atlas-form-sdk pattern.
 */

import { BaseHttpClient } from './http.client';
import { atlasApiConfig } from './config';
import type { ApiResponse, FormCategory, FormType } from '@atlas-forms/types-js';

const EP = {
  CATEGORIES: '/api/v1/atlas/form-categories/list',
  TYPES:      '/api/v1/atlas/form-types/list',
} as const;

export class FormCategoryApiClient extends BaseHttpClient {
  constructor(config?: { baseUrl?: string; timeout?: number }) {
    super({
      baseUrl: config?.baseUrl ?? atlasApiConfig.baseUrl,
      timeout: config?.timeout ?? atlasApiConfig.timeout,
    });
  }

  async listCategories(request: Record<string, unknown> = {}): Promise<ApiResponse<FormCategory[]>> {
    return this.postQuery<FormCategory[]>(EP.CATEGORIES, request);
  }
}

export class FormTypeApiClient extends BaseHttpClient {
  constructor(config?: { baseUrl?: string; timeout?: number }) {
    super({
      baseUrl: config?.baseUrl ?? atlasApiConfig.baseUrl,
      timeout: config?.timeout ?? atlasApiConfig.timeout,
    });
  }

  async listTypes(request: Record<string, unknown> = {}): Promise<ApiResponse<FormType[]>> {
    return this.postQuery<FormType[]>(EP.TYPES, request);
  }
}

export const formCategoryApiClient = new FormCategoryApiClient();
export const formTypeApiClient = new FormTypeApiClient();
